import dayjs from "dayjs";
import i18n from "i18next";
import { useEffect } from "react";
import { dateLocales } from "../../locales";
import { useTheme } from "../../theme/ThemeProvider";

function useLocale() {
  const { locale } = useTheme();

  useEffect(() => {
    const formattedLang = locale.replace(/-([a-z])/g, (g: string) =>
      g[1].toUpperCase(),
    );
    if (locale !== i18n.language) {
      i18n.changeLanguage(formattedLang);
    }
    const loader = dateLocales[formattedLang as keyof typeof dateLocales];
    loader().then(() => {
      dayjs.locale(formattedLang);
    });
  }, [locale]);

  return locale;
}

export default useLocale;
